// Lib
import { percentFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const avgEngagementRateHistoryConfig = {
    title: 'chart.linkedin.avg_engagement_rate_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.linkedin.avg_engagement_rate_history_name'
    },
    disableGraphData: ['count_posts'],
    id: 'average_engagement_rate_history',
    color: {
        value: 'green'
    },
    valueFormat: { ...percentFormat, maximumFractionDigits: 4 },
    tooltip: 'chart.linkedin.tooltip_avg_engagement_rate_history',
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
